import { Injectable } from '@angular/core';
// import {BehaviorSubject} from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
@Injectable()
export class StoreService {

  constructor() { }

  // 依赖更新部分
  store:object = {
    loadingComponent:{
      loading:false
    }
  }
  //通知机制部分
  notification:any = {
    notAuthed:new BehaviorSubject(null),//登录于否
    isChannel:new BehaviorSubject(null),
    askImmediately:new BehaviorSubject(null),
    refreshHomePage:new BehaviorSubject(null),
    mentorEntered:new BehaviorSubject(null),
  }

  commit(nameSpace:string,data:any){
    this.store[nameSpace] = Object.assign(this.store[nameSpace] || {},data)
  }
  getter(nameSpace:string,key:string){
    return this.store[nameSpace][key];
  }
}



// WEBPACK FOOTER //
// ./src/app/store.service.ts